export const KEY_NO_CACHE = (extraKey?: string) => `key_no_cache:${extraKey}`;
export const KEY_PREV_PAIR = (address?: string) => `prev_pair${address}`;
export const KEY_PREV_SWAP = (address?: string) => `prev_swap${address}`;
